import React from 'react'
import Expander from '../Expander'
import Text from '../Text'

export default function(notification, size = 1) {
  return (
    <Expander size={size} id={notification.id} label={notification.subtitle}>
      <Text size={size}>
        <span dangerouslySetInnerHTML={{ __html: notification.message }} />
      </Text>
    </Expander>
  )
}
